const home = {

  init: () => {
    if ($('.our-products-slider')[0]) {
      $('.our-products-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 16000,
        infinite: true,
        cssEase: 'linear',
        waitForAnimate: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 0,
              speed: 16000,
              infinite: true,
              cssEase: 'linear',
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
              autoplay: true,
              autoplaySpeed: 4000,
              speed: 400,
              infinite: true,
              cssEase: 'linear',
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              autoplay: true,
              autoplaySpeed: 4000,
              speed: 400,
              infinite: true,
              cssEase: 'linear',
            }
          }
        ]
      });
    }

    var ourslider = $('.our-products-slider');
    var autoplay = true;
    var restartAutoplay;

    $(document).on('click', '.our-products-slider-next', function() {
      if (autoplay == true) {

        ourslider.slick("slickSetOption", 'speed', 1000, true);
        ourslider.slick("slickSetOption", 'autoplay', false, true);
        autoplay = false;

        ourslider.slick('slickPrev');

        restartAutoplay = window.setTimeout(() => {
          ourslider.slick("slickSetOption", 'speed', 16000, true);
          ourslider.slick("slickSetOption", 'autoplay', true, true);
          autoplay = true;
        }, 5000);

      } else {

        ourslider.slick('slickNext');

        window.clearTimeout(restartAutoplay);
        restartAutoplay = window.setTimeout(() => {
          ourslider.slick("slickSetOption", 'speed', 16000, true);
          ourslider.slick("slickSetOption", 'autoplay', true, true);
          autoplay = true;
        }, 5000);

      }
    });

    if ($('.press-quotes')[0]) {
      $('.press-quotes').on('afterChange', function(event, slick, currentSlide, nextSlide){
        console.log(currentSlide);
        $('.is-desk .press-quotes-page').removeClass('is-active');

        $('.is-desk .press-quotes-page[data-index="'+currentSlide+'"]').addClass('is-active');
      });

      $('.press-quotes').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.press-quotes-pager.is-mob',
        draggable: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              draggable: true,
              dots: false
            }
          }
        ]
      });

      $('.press-quotes-pager.is-mob').slick({
        // slidesToShow: 6,
        // slidesToScroll: 6,
        // asNavFor: '.press-quotes',
        // dots: false,
        // arrows: false,
        // centerMode: false,
        // focusOnSelect: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.press-quotes',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
              centerMode: true,
              fade: true
            }
          }
        ]
      });
      let isLoading = false
      $('body').on('mouseover', '.is-desk .press-quotes-page', function (){
        if(isLoading == false) {
          isLoading= true;
          $('.press-quotes').slick('slickGoTo', parseInt($(this).attr('data-index')));
          $('.is-desk .press-quotes-page').removeClass('is-active');
          $(this).addClass('is-active');
          setTimeout(()=>{
            isLoading= false;
          }, 10)
        }
      })
    }

    if ($('.value-prop-column-props')[0]) {
      $('.value-prop-column-props').slick({
        dots: false,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              centerMode: true,
              dots: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      });
    }

    if ($('.hp-about-features')[0]) {
      $('.hp-about-features').slick({
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              centerMode: false,
              dots: false,
              adaptiveHeight: false
            }
          }
        ]
      });
    }

    $(document).on('click', '.hp-about-slider-next', function() {
      $('.hp-about-features').slick('slickNext');
    });

  }



};
export default home;
